import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateEntityWithChildIds } from 'src/shared/entities/utils/generate-base-entity'

export function createCarousel(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): CarouselInterface {
  return {
    ...generateEntityWithChildIds(
      EntityTypeEnum.Carousel,
      parentId,
      masterBlockId,
    ),
    controlsColor: 'rgba(255, 255, 255, 1)',
    arrowsColor: 'rgba(255, 255, 255, 1)',
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    showArrows: true,
  }
}
